import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-bar', 'ChartBar', [["path",{"d":"M17 21V3m-5 18V9M7 21v-5","key":"svg-0"}]]);